var r="KK";export{r as DEFAULT_PROFILE_INITIALS};
//# sourceMappingURL=strings.js.map
